// extracted by mini-css-extract-plugin
module.exports = {"position":"Label_position__348d1"};